/**
 * Scroll-triggered chroma sweep on the heading accent.
 *
 * Mirrors the React reference src/ui/chroma-reveal.tsx: the span carries the
 * heading colour until it first intersects, then SWAPS to the gradient classes
 * — `text-grey-100` goes away, `chroma-text chroma-sweep-animate` come in.
 * Keeping the colour class alongside them, as this file used to, left the DOM
 * with a class the reference never has (harmless to the paint, because the
 * unlayered block stylesheet's `.chroma-text` wins the cascade, but it is a
 * difference the parity trace reads).
 *
 * The JS hook is the `data-chroma-reveal` attribute, not a class, for the same
 * reason: className is part of the contract being compared, attributes are not.
 * It also stops the sibling blocks that query `.chroma-reveal-accent` globally
 * from observing this span as well.
 *
 * @param {HTMLElement} el The heading accent span.
 */
function initChromaReveal( el ) {
	const observer = new window.IntersectionObserver(
		( entries ) => {
			for ( const entry of entries ) {
				if ( entry.isIntersecting ) {
					el.classList.remove( 'text-grey-100' );
					el.classList.add( 'chroma-text', 'chroma-sweep-animate' );
					observer.disconnect();
					break;
				}
			}
		},
		{ threshold: 0.4 }
	);
	observer.observe( el );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '[data-chroma-reveal]' )
		.forEach( initChromaReveal );
} );
